// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"Share":"5ee7a9815544a433ad7e","ContentImport":"85f4bacb63b96d72443e","Queue":"907115da7898731e4d48","Stats":"08b048540a819b2f9a25","Settings":"8707c495d7a049fcd6b0","ClientApp":"f9cc7b1afa32419610aa"}[chunkId] + ".bundle.js";
};